module.exports = __webpack_public_path__ + "img/Poorter_hotel-060.d656fa68.jpg";